<template>
  <BaseVeeForm :action="trySubmit" v-slot="{ isPending, invalid }" class="space-y-6">
    <ValidationProvider rules="required" name="url" slim vid="url">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="url"> Url </BaseFormLabel>
          <BaseFormInput id="url" v-model="formData.url" type="url" :disabled="isPending" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="title" slim vid="title">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="title"> Title </BaseFormLabel>
          <BaseFormInput id="title" v-model="formData.title" :disabled="isPending" />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="description" slim vid="description">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="description"> Description </BaseFormLabel>
          <BaseFormTextarea
            id="description"
            rows="3"
            v-model="formData.description"
            :disabled="isPending"
          />
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <ValidationProvider name="tags" slim vid="tags">
      <template #default="{ errors }">
        <BaseFormGroup>
          <BaseFormLabel for="tags"> Tags </BaseFormLabel>
          <ul class="flex flex-wrap">
            <template v-for="tag in tags">
              <li :key="tag.id" class="p-1">
                <label
                  class="inline-flex p-1 border border-transparent text-sm rounded-full focus-within:ring ring-blue-500 ring-opacity-50 focus-within:border-blue-700"
                  :class="[
                    formData.tags.indexOf(tag.id) > -1 ? 'bg-blue-600 text-white' : 'bg-gray-200',
                  ]"
                >
                  <input
                    v-model="formData.tags"
                    type="checkbox"
                    :value="tag.id"
                    class="appearance-none opacity-0"
                  />
                  <div class="flex items-center px-2 space-x-2">
                    <span class="inline-flex leading-4">
                      {{ tag.name }}
                    </span>
                  </div>
                </label>
              </li>
            </template>
          </ul>
          <BaseFormInlineMessage v-if="errors.length" danger>
            {{ errors[0] }}
          </BaseFormInlineMessage>
        </BaseFormGroup>
      </template>
    </ValidationProvider>

    <div class="flex space-x-2">
      <BaseButton primary :disabled="isPending || invalid">
        {{ label }}
      </BaseButton>
    </div>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'AssetLinkForm',
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    defaultData: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: 'Submit',
    },
    action: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        url: this.defaultData?.url || '',
        title: this.defaultData?.title || '',
        description: this.defaultData?.description || '',
        tags: [...(this.defaultData?.tags || [])],
      },
    };
  },
  computed: {
    selectedTags: {
      get() {
        return this.formData.tags
          .map((tagId) => this.tags.find((tag) => tag.id === tagId))
          .filter((tag) => tag);
      },
      set(tags) {
        this.formData.tags = tags.map((tag) => tag.id);
      },
    },
  },
  methods: {
    limitText(count) {
      return `and ${count} more tags`;
    },
    async trySubmit() {
      try {
        await this.action(this.formData);
        this.$emit('success');
        return Promise.resolve();
      } catch (error) {
        this.$emit('failure');
        return Promise.reject(error);
      }
    },
  },
};
</script>
